<div id="shared-tooltip-container" class="tooltip">
  <span
    id="shared-tooltip-wrapper"
    mat-raised-button
    #tooltip="matTooltip"
    [matTooltipDisabled]="disabled"
    matTooltip="{{ tootltipText }}"
    [matTooltipPosition]="tooltipPosition"
    matTooltipHideDelay="{{ tooltipDelay }}"
    aria-label="Tooltip for any component"
    [ngClass]="['tooltip-span', tooltipCustomClass]"
  >
    <ng-content id="shared-tooltip-content" select=".tooltip-content"></ng-content>
  </span>
</div>
